import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from "../../../apiClient";
import { ProductDto } from "../../../models/product/dto/product.dto";
import { GET_PRODUCT_QUERY_KEY } from "./useGetProduct";

export const useDeleteProduct = (onSuccess?: () => void) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteProduct'],
        mutationFn: async (id: string) => {
            await apiClient.fetchApi<void, {}>({
                method: 'DELETE',
                endpoint: `products/${id}`
            });
            return id;
        },
        onSuccess: (deletedId) => {
            // Remove from specific product cache
            queryClient.removeQueries({ queryKey: GET_PRODUCT_QUERY_KEY(deletedId) });

            // Remove from all products lists
            queryClient.setQueriesData<ProductDto[]>(
                { queryKey: ['products'] },
                (prevList = []) => {
                    return prevList.filter(product => product.id !== deletedId);
                }
            );

            onSuccess?.();
        }
    });
};
